import React, { FC, useState } from 'react'
import classNames from 'classnames'
import { PlayIcon } from '@/atoms/Icons/PlayIcon'
import { Image } from '@/atoms/Image'
import { EmbeddedVideo } from '@/molecules/EmbeddedVideo'
import { CRITIC_IMAGES } from '@/views/TicketCheckoutViews/ShowtimesView/components/ShowtimeDetailsPanel/ShowtimeDetailsPanel'

interface Props {
  imageUrl: string
  trailerUrl: string
  className?: string
  isVerifiedHot?: boolean
}
export const TheatricalTrailer: FC<Props> = ({ imageUrl, trailerUrl, className, isVerifiedHot }) => {
  const [loadPlayer, setLoadPlayer] = useState(false)
  return (
    <button
      onClick={() => setLoadPlayer(true)}
      className={classNames(
        'block aspect-w-16 aspect-h-9 rounded-[10px] w-full relative cursor-pointer border border-transparent overflow-hidden group focus-visible:border-black focus-visible:ring-[1px] focus-visible:ring-white',
        className,
      )}
    >
      {!loadPlayer && (
        <div>
          <Image priority alt="Video player thumbnail" src={imageUrl} fill sizes="(min-width: 1024px) 410px" />

          <div className="absolute inset-0 transition-colors duration-150 ease-in-out group-hover:bg-black/30 group-active:bg-black/50" />

          <div className="absolute left-1/2 top-1/2 flex h-[64px] w-[64px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/20 backdrop-blur-[48px] transition-all duration-150 ease-in-out group-hover:-translate-y-[calc(50%+2px)] group-hover:bg-white/50 group-focus-visible:-translate-y-[calc(50%+2px)] group-active:bg-white/20">
            <PlayIcon size={32} color="white" />
          </div>

          {isVerifiedHot && (
            <Image
              priority
              alt=""
              src={CRITIC_IMAGES['VERIFIED_HOT']}
              width={64}
              height={64}
              className="absolute !top-[12px] right-[12px] h-[64px] w-[64px]"
            />
          )}
        </div>
      )}

      {loadPlayer && (
        <div className="overflow-hidden rounded-xl">
          <EmbeddedVideo className="rounded-xl" title="Official Theatrical Trailer" url={`${trailerUrl}?autoplay=1`} />
        </div>
      )}
    </button>
  )
}
